import { RetailerOpeningHoursType } from 'src/modules/retailer/components/openingHours/RetailerOpeningHours';
import { GlobalFilterItem } from 'src/modules/global/components/filter/GlobalFilter';
import { ImageEntity } from 'src/modules/global';

export enum RetailerActions {
  FetchRetailerBegin = 'RETAILER/FETCH/BEGIN',
  FetchRetailerSuccess = 'RETAILER/FETCH/SUCCESS',
  FetchRetailerError = 'RETAILER/FETCH/ERROR',
  SetFilter = 'RETAILER/SET_FILTER',
  SetMap = 'RETAILER/SET_MAP',
  ChangeMapBounds = 'RETAILER/CHANGE_MAP_BOUNDS',
  SetMarkers = 'RETAILER/SET_MARKERS',
  SetCurrentLocation = 'RETAILER/SET_CURRENT_LOCATION',
}

export interface RetailerEntity {
  id: number;
  slug?: string;
  name: string;
  description?: string;
  street?: string;
  zip?: string;
  city?: string;
  countryCode?: string;
  phone?: string;
  email?: string;
  partnership?: RetailerPartnership;
  notification_de?: string;
  notification_en?: string;
  lat?: number;
  lng?: number;
  opening_hours?: RetailerOpeningHoursType;
  category?: RetailerCategory;
  lastModified?: number;
  type?: RetailerType;
  link?: string;
  quickShip?: boolean;
  distance?: number;
  ids?: number[];
  image: ImageEntity;
  brandspace_type?: BrandSpaceType;
}

export enum RetailerType {
  Dealer = 'dealer',
  WebOfficialDealer = 'web_official_dealer',
  BrandSpace = 'brand_space',
}

export enum RetailerCategory {
  Living = 'living',
  Office = 'office',
  LivingOffice = 'living_office',
}

export enum RetailerPartnership {
  selectedBrandPartner = 'selected_brand_partner',
  brandPartner = 'brand_partner',
}

export enum BrandSpaceType {
  Headquarters = 'headquarters_showroom',
  Brandspace = 'brand_space',
}
// export interface RetailerActionType {
//   type: RetailerActions;
//   payload?: {
//     location?: Coordinate;
//     markers?: RetailerMarker[];
//     map?: google.maps.Map;
//     filters?: GlobalFilterItem[];
//   };
// }

// export interface RetailerActionPayloadType {
//   type: RetailerActionType;
//   payload?: any;
// }
// export type SetMapActionType = (map: google.maps.Map) => RetailerActionPayloadType;
// export type ChangeMapBoundsActionType = () => RetailerActionPayloadType;
// export type SetCurrentLocationActionType = (Coordinate) => RetailerActionPayloadType;
// export type SetRetailerMarkersActionType = (
//   markers: RetailerMarker[] | google.maps.Marker[]
// ) => RetailerActionPayloadType;

export type CompanyStatus = {
  [company: string]: Record<string, unknown>;
};

export type CompanyType = {
  [type: string]: Record<string, unknown>;
};

export interface RetailersStore {
  retailers: RetailerEntity[];
  visibleRetailers?: RetailerMarker[];
  filters?: GlobalFilterItem[];
  markers: RetailerMarker[];
  map: google.maps.Map;
  currentLocation: Coordinate;
}

export type OnStoreHover = (storeId: number, scroll: boolean) => void;

export interface RetailerMarker extends RetailerEntity, google.maps.Marker {}

export interface Coordinate {
  lat: number;
  lng: number;
}

export interface ActiveRetailer {
  id: number;
  scroll: boolean;
}

export enum MarkerAction {
  Deactivate,
  Activate,
}
